import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletHeaderBackground = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 307.658,
	height: 309.489,
	viewBox: "0 0 307.658 309.489",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Wallet Background",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Polygon 9",
			opacity: .3,
			filter: "url(#filter0_d_0_430)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M94.3927 46.5124C130.236 25.8222 174.402 25.8297 210.252 46.5319L222.734 53.7396C258.585 74.4419 280.674 112.694 280.681 154.087L280.683 168.497C280.69 209.89 258.614 248.135 222.77 268.825L210.291 276.029C174.447 296.719 130.282 296.712 94.4312 276.009L81.9495 268.802C46.0987 248.099 24.0094 209.847 24.0024 168.454L24 154.044C23.9931 112.651 46.0695 74.4063 81.9134 53.7159L94.3927 46.5124Z",
				fill: "url(#paint0_linear_0_430)",
				fillOpacity: .5,
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M94.5759 46.8296C130.306 26.2049 174.332 26.2123 210.069 46.849L222.551 54.0571C258.288 74.694 280.308 112.825 280.315 154.087L280.317 168.497C280.324 209.759 258.317 247.883 222.587 268.508L210.107 275.711C174.377 296.336 130.352 296.329 94.6143 275.692L82.1326 268.485C46.3953 247.848 24.3758 209.716 24.3688 168.455L24.3664 154.044C24.3594 112.782 46.3662 74.6585 82.0966 54.0336L94.5759 46.8296Z",
				stroke: "url(#paint1_linear_0_430)",
				strokeOpacity: .5,
				strokeWidth: .732927,
				shapeRendering: "crispEdges"
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Polygon 10",
			opacity: .2,
			filter: "url(#filter1_d_0_430)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M115.016 60.9644C151.395 37.822 197.173 37.1005 232.896 59.1066V59.1066C265.027 78.9003 284.203 114.156 283.647 152.415L283.413 168.511C282.857 206.77 262.648 242.646 229.926 263.462V263.462C193.547 286.605 147.77 287.326 112.047 265.32V265.32C79.9153 245.526 60.7397 210.271 61.2956 172.011L61.5295 155.916C62.0855 117.656 82.2947 81.78 115.016 60.9644V60.9644Z",
				fill: "url(#paint2_linear_0_430)",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M115.206 61.2715C151.465 38.2056 197.092 37.4865 232.697 59.4199C264.722 79.1482 283.834 114.288 283.28 152.421L283.046 168.516C282.492 206.65 262.35 242.407 229.736 263.154C193.477 286.22 147.851 286.939 112.246 265.006C80.2205 245.277 61.1083 210.139 61.6625 172.005L61.8963 155.91C62.4505 117.777 82.5928 82.0185 115.206 61.2715Z",
				stroke: "url(#paint3_linear_0_430)",
				strokeWidth: .732927,
				shapeRendering: "crispEdges"
			})]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_0_430",
			x: 0,
			y: 0,
			width: 304.683,
			height: 308.541,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -7 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.905 0 0 0 0 0.525 0 0 0 0 1 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_0_430"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_0_430",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_0_430",
			x: 37.2839,
			y: 12.091,
			width: 270.374,
			height: 286.245,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -7 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.905 0 0 0 0 0.525 0 0 0 0 1 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_0_430"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_0_430",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_0_430",
			x1: 58.6688,
			y1: 59.9257,
			x2: 375.922,
			y2: 456.874,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#135D66",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_0_430",
			x1: 302.722,
			y1: 370.096,
			x2: -19.2173,
			y2: 21.1208,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#135D66",
				stopOpacity: .37
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#135D66",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_0_430",
			x1: 92.8086,
			y1: 68.3901,
			x2: 221.778,
			y2: 240.731,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#135D66",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_0_430",
			x1: 299.723,
			y1: 356.128,
			x2: 1.05093,
			y2: 57.9831,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#135D66",
				stopOpacity: .37
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#135D66",
				stopOpacity: 0
			})]
		})
	] })]
});
export default SvgWalletHeaderBackground;
